var Backbone = require('backbone');
var _ = require('underscore');

var Base = require('front/components/Base/Base');

require('./Consultation.less');

module.exports = Base.extend({
    template: require('./Consultation.jinja'),

    el: '.Consultation',

    events: {
        'click': 'onClick'
    },

    initialize: function (options) {
        Base.prototype.initialize.call(this, options);

        _.bindAll(this, 'activateIndexLogic', 'deactivateIndexLogic', 'activateSticky', 'deactivateSticky');

        this.isSticky = options.isSticky || false;

        this.isIndex = false;

        if (!app.settings.isMobile) {
            if (this.isSticky) {
                app.vent.on('activateIndex', this.activateIndexLogic);
                app.vent.on('deactivateIndex', this.deactivateIndexLogic);

                app.vent.on('Consultation.activateSticky', this.activateSticky);
                app.vent.on('Consultation.deactivateSticky', this.deactivateSticky);

                this.onResize.__throttled = _.throttle(this.onResize.bind(this), 20);
                $(window).on('resize', this.onResize.__throttled);
                this.onResize.__throttled();
            }

            this.onScroll.__throttled = _.throttle(this.onScroll.bind(this), 20);
            $(window).on('scroll', this.onScroll.__throttled);

            this.onScroll.__throttled();
        }
    },

    activateIndexLogic: function () {
        this.isIndex = true;

        if (!app.settings.isMobile) this.onScroll.__throttled();
    },

    deactivateIndexLogic: function () {
        this.isIndex = false;

        this.$el.addClass('Consultation--isVisible');
    },

    activateSticky: function () {
        if (!this.isIndex) return;

        this.$el.addClass('Consultation--isVisible');
    },

    deactivateSticky: function () {
        if (!this.isIndex) return;

        this.$el.removeClass('Consultation--isVisible');
    },

    onScroll: function () {
        var $footer = $('.Footer');
        var scrollTop = $(window).scrollTop();
        var height = this.$el.innerHeight();
        var navHeight = $('.Nav').outerHeight();
        var offsetCons = (scrollTop + $(window).innerHeight()) - height;
        var delta = 5; // Fix responsive bug

        if (!this.isSticky) {
            if (scrollTop > this.$el.offset().top + height - navHeight) {
                app.vent.trigger('Consultation.activateSticky');
            } else {
                app.vent.trigger('Consultation.deactivateSticky');
            }

            return;
        }

        if ($footer.offset().top <= offsetCons + delta) {
            this.$el.addClass('Consultation--stop');
        } else {
            this.$el.removeClass('Consultation--stop');
        }

        this.onResize.__throttled();
    },

    onResize: function () {
        var wWidth = $('html')[0].clientWidth;
        var rightCons = 0;

        if (wWidth < 960 && !this.$el.hasClass('Consultation--stop')) {
            rightCons = 960 - wWidth;
            this.$el.css('right', -rightCons + 'px');
        } else {
            this.$el.css('right', 0);
        }
    },

    onClick: function () {
        Chatra.openChat();
    },

    destroy: function () {
        $(window).unbind('scroll', this.onScroll.__throttled);

        Base.prototype.destroy.call(this);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Consultation/Consultation.js
// module id = 18
// module chunks = 0